import Avatar from "@/ui/avatar";

import { useToken } from "../../../hooks/use-token";
import { Price } from "@/ui/formats";
import Input from "@/ui/input";
import clsx from "clsx";
import { formatDecimalStringFloat } from "@/utils/currency";

const LimitInput = ({
  isInstant,
  triggerPrice,
  limit,
  onLimitChange,
}: {
  isInstant: boolean;
  triggerPrice: string;
  limit: string;
  onLimitChange: (limit: string) => void;
}) => {
  const token = useToken();

  return (
    <div className="flex relative items-center justify-center my-[0.313rem]">
      <div className="flex items-center gap-x-[0.313rem]">
        <Avatar
          source={token?.icon ?? ""}
          size="token"
          fallbackLetter={token?.symbol?.[0]}
        />
        <span className="flex items-center text-xs gap-x-[0.188rem]">
          <span className="font-semibold">Price: </span>
          <Price
            value={
              triggerPrice !== ""
                ? Number(triggerPrice)
                : Number(token?.price ?? 0)
            }
            inherited={isInstant ? "default" : "grey"}
            decimals={7}
          />
        </span>
      </div>
      <div
        className="absolute right-0 h-[1.375rem] max-w-[6.438rem] min-w-[2.438rem] text-xs"
        style={{
          width: `${Math.min(String(limit).length * 0.45 + 2, 4.5)}rem`,
        }}
      >
        <Input
          value={limit}
          className={clsx(
            "!h-[1.375rem] text-end w-auto",
            Number(limit) === 0
              ? "!text-grey"
              : Number(limit) > 0
                ? "!text-aqua"
                : "!text-blue"
          )}
          radius="smallInput"
          placeholder="0"
          onChange={(v) => {
            if (Number(v) < -99.99) {
              return;
            }

            const formattedValue = formatDecimalStringFloat(v);

            onLimitChange(formattedValue);
          }}
          rightSide={
            <div className="h-full pr-[0.54rem]">
              <Input.Accordion>%</Input.Accordion>
            </div>
          }
        />
      </div>
    </div>
  );
};

export default LimitInput;
